import components from 'assets/translations/ru/components.json';
import common from 'assets/translations/ru/common.json';
import views from 'assets/translations/ru/views.json';
export default {
    components: components,
    common: common,
    views: views
};
